import { isEqual } from "lodash";
import type { ActionEditProps } from "~/components/Actions/pluginRegistry";

export function ValueInPropertiesOrErrorsHasChanged(keysObject: Record<string, string>, newProps: ActionEditProps, props: ActionEditProps) {
    return !isEqual(newProps.errors, props.errors) || Object.keys(keysObject).some((p) => newProps.properties[p] !== props.properties[p]);
}
